<template>
	<cards-view :fanzoneTypesIds='[3]' url='fanzone-places' />
</template>

<script>
	import cardsView from '../components/CardsView'
	
	export default {
		components: { cardsView }
	}
</script>
